/**
 * @author Marco Visin
 * @date 2025-06-02
 */

import { INodeProperties } from 'n8n-workflow';

export const userOperations: INodeProperties[] = [
	{
		displayName: 'Operation',
		name: 'operation',
		type: 'options',
		noDataExpression: true,
		displayOptions: {
			show: {
				resource: ['user'],
			},
		},
		options: [
			{
				name: 'Get',
				value: 'get',
				description: 'Get current user information',
				action: 'Get user',
			},
			{
				name: 'Get CV',
				value: 'getCv',
				description: 'Get user CV information including preferences and last update',
				action: 'Get user CV',
			},
		],
		default: 'get',
	},
];

export const userFields: INodeProperties[] = [
	// No additional fields needed for user operations
];
